module.exports = __webpack_public_path__ + "media/application/images/news/secondary_nav/blog-8209da682b6de5472b3d486b0012d402.jpg";